import { render, staticRenderFns } from "./GroupConsent.vue?vue&type=template&id=37980429&scoped=true&"
import script from "./GroupConsent.vue?vue&type=script&lang=js&"
export * from "./GroupConsent.vue?vue&type=script&lang=js&"
import style0 from "./GroupConsent.vue?vue&type=style&index=0&id=37980429&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37980429",
  null
  
)

export default component.exports